<div class="m-multi-row" [formGroup]="income">
	<div class="form-row row">

		<button type="button"  *ngIf="displayX" class="close" aria-label="Close" (click)="removed.emit(index)">
			<span aria-hidden="true">&times;</span>
		</button>

		<div class="form-group col-12 col-md-6">
			<div *ngIf="index===0" class="text-right m-title">
				{{titles[0] | translate}}
			</div>
			<select formControlName="type" [attr.id]="'type'+index" 
			class="form-control m-sm-form-control" 
			[attr.aria-label]="titles[0]|translate">
				<option [value]="defaultValue">{{ph[0]}}</option>
				<option *ngFor="let option of type" [value]="option">{{option}}</option>
			</select>
			<div class="m-error" *ngIf="income.get('type').hasError('required') && displayErrors">
				{{ 'COMMON.FIELD_REQUIRED_FROM_LIST' | translate }}
			</div>
		</div>

		<div class="form-group col-12 col-md-6">
			<div class="row" *ngIf="income.get('type').value === 'אחר' && needSources ">
				<div class="col-12 col-md-6">
					<div *ngIf="index===0" class="text-right m-title">
						{{ titles[1] | translate }}
					</div>
					<input currencyMask type="tel" formControlName="amount" [attr.id]="'amount'+index" class="form-control m-sm-form-control" [attr.aria-label]="titles[1]|translate"/>
					<div class="m-error" *ngIf="income.get('amount').hasError('required') && displayErrors">
						{{ 'COMMON.FIELD_REQUIRED' | translate }}
					</div>
					<div class="m-error" *ngIf="income.get('amount').hasError('min') && displayErrors">
						{{ 'COMMON.FIELD_REQUIRED' | translate }}
					</div>
				</div>


				<div class="col-12 col-md-6">
					<div *ngIf="index===0" class="text-right m-title">
						{{ titles[2] | translate }}
					</div>
					<input type="text" placeholder="{{ph[1]}}" formControlName="source" [attr.id]="'source'+index" class="form-control m-sm-form-control" [attr.aria-label]="titles[2]|translate"/>
					<div class="m-error" *ngIf="income.get('source').hasError('required') && displayErrors">
						{{ 'COMMON.FIELD_REQUIRED' | translate }}
					</div>
					<div class="m-error" *ngIf="income.get('source').hasError('min') && displayErrors">
						{{ 'COMMON.FIELD_REQUIRED' | translate }}
					</div>
				</div>
			</div>

			<div *ngIf="income.get('type').value !== 'אחר' || !needSources">
					<div *ngIf="index===0" class="text-right m-title">
							{{ titles[1] | translate }}
					</div>
					<input currencyMask type="tel" formControlName="amount" [attr.id]="'amount'+index" class="form-control m-sm-form-control" [attr.aria-label]="titles[1]|translate"
					/>
					<div class="m-error" *ngIf="income.get('amount').hasError('required') && displayErrors">
						{{ 'COMMON.FIELD_REQUIRED' | translate }}
					</div>
					<div class="m-error" *ngIf="income.get('amount').hasError('min') && displayErrors">
						{{ 'COMMON.FIELD_REQUIRED' | translate }}
					</div>
			</div>
			
		</div>
	</div>


// WEBPACK FOOTER //
// ./src/app/line-other-income/line-other-income.component.html